import { Button } from "common/components/ui/Button";
import { DialogDescription, DialogTitle } from "common/components/ui/Dialog";
import { DrawerDescription, DrawerTitle } from "common/components/ui/Drawer";
import usePromotionsMutations from "common/datahooks/usePromotionsMutations";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";

interface ResetSeatsProps {
  goBack: () => void;
  source: "appsumo" | "ltd";
}

export default function ResetSeats({ goBack, source }: ResetSeatsProps) {
  const isDesktop = useTwBreakpoint("lg");
  const { resetSeats, isResettingSeats } = usePromotionsMutations();

  function onReset() {
    resetSeats({ source }).then(goBack);
  }

  const Title = isDesktop ? DialogTitle : DrawerTitle;
  const Description = isDesktop ? DialogDescription : DrawerDescription;

  return (
    <>
      <Title>Reset all seats and workspaces</Title>

      <Description className="mb-8 lg:mb-12">
        This action will reset and un-assign all of your lifetime seats and
        workspaces. Campaigns for accounts using these seats will stop. After
        resetting, you can re-assign seats and workspaces however you wish
      </Description>

      <div className="flex justify-between gap-x-2.5">
        <Button
          variant="secondary-black"
          className="lg:flex-1"
          onClick={goBack}
          disabled={isResettingSeats}
        >
          Cancel
        </Button>

        <Button
          variant="outline-danger"
          className="lg:flex-1"
          onClick={onReset}
          isLoading={isResettingSeats}
        >
          Reset
        </Button>
      </div>
    </>
  );
}
